import React from 'react'
import {CBadge,CDropdown,CDropdownItem,CDropdownMenu,CDropdownToggle,CImg} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { local } from 'brownies';
import {useHistory} from 'react-router-dom';
import { Avatar } from 'antd';
import {connect} from 'react-redux'

import http from '../config'
import {setAuthenticated} from '../redux/actions/index'

const TheHeaderDropdown = (props) => {
  const history = useHistory();
  let url = '/login'
  let profileUrl = '/profile'

  const handleLogout = async() => {
    try{
      await http.post('/auth/log-out');
      emptySessions();
    }
    catch(err){
      emptySessions();
    }
  }
  const emptySessions = () =>{
    local.access_token=null;
    local.isAuthenticated=false
    local.expires_in=null;
    props.setAuthenticated(false)
    history.push(url);
  }
  return (
    <CDropdown
      inNav
      className="c-header-nav-items mx-2"
      direction="down"
    >
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <div className="c-avatar">
          <Avatar>{props.user && props.user.first_name ? props.user.first_name.charAt(0) : 'A'}</Avatar>
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownItem
          header
          tag="div"
          color="light"
          className="text-center"
        >
          <strong>Settings</strong>
        </CDropdownItem>
        <CDropdownItem
          onClick={()=>history.push(profileUrl)}
        >
          <CIcon name="cil-user" className="mfe-2" />Profile
        </CDropdownItem>
        <CDropdownItem
          onClick={()=>history.push('/users')}
        >
          <CIcon name="cil-settings" className="mfe-2" />
          Settings
        </CDropdownItem>
        <CDropdownItem onClick={handleLogout}>
          <CIcon name="cil-account-logout" className="mfe-2" />
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}
const mapStateToProps = state =>({
  user: state.auth.user
})
export default connect(mapStateToProps,{setAuthenticated})(TheHeaderDropdown)
